export class AuthInfoModel {
    currentCustomerCode: string | null;
    idToken: string | null;
    didAutoLogout: boolean;

    constructor(currentCustomerCode: string | null, idToken: string | null, didAutoLogout: boolean) {
        this.currentCustomerCode = currentCustomerCode;
        this.idToken = idToken;
        this.didAutoLogout = didAutoLogout;
    }

    public static createWithDefaults(): AuthInfoModel {
        return new this(null, null, false);
    }
}
